import { Component, effect, inject, signal } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import {
	LocationSearchDto,
	ModulesEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { takeUntil } from 'rxjs';

import { BaseLinkCardComponent } from '../../../../../shared/base-classes/base-link-card.component';
import { LinkCardContainerComponent } from '../../../../../shared/components/containers/link-card-container/link-card-container.component';
import { GetTranslationKeyForValuePipe } from '../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { StackLabelItemComponent } from '../../../../../shared/components/dropdowns/stack-label-item/stack-label-item.component';
import { SelectItem } from '../../../../../shared/models/select-item.type';
import { LocationsService } from '../../locations.service';
import { mapDtoToModelLocations } from '../../mappers/search-dto-to-model.mapper';
import { LOCATION_TYPES } from '../../translations/locations-select-items';

@Component({
	selector: 'app-location-link-card',
	templateUrl: 'location-link-card.component.html',
	standalone: true,
	imports: [
		LinkCardContainerComponent,
		TranslocoModule,
		StackLabelItemComponent,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
	],
	host: {
		class: 'w-full',
	},
})
export class LocationLinkCardComponent extends BaseLinkCardComponent<
	SelectItem<LocationSearchDto>
> {
	moduleUrl = signal(ModulesEnum.LOCATIONS);
	#locationsService = inject(LocationsService);
	types = LOCATION_TYPES;

	constructor() {
		super();

		this.module = ModulesEnum.LOCATIONS;
		effect(() => {
			this.pingerSignal();
			if (!this.id()) {
				this.link.set(null);
				this.isLoading.set(true);
				return;
			}
			this.#locationsService
				.getSearchResults('', [this.id()])
				.pipe(takeUntil(this._unsubscribeAll))
				.subscribe((res) => {
					if (!res.data) {
						return;
					}
					this.isLoading.set(false);
					this.link.set(mapDtoToModelLocations(res.data)[0]);
				});
		});
	}
}
